import { useMemo } from 'react';

import {
  NutritionMenuItem,
  NutritionMenuItemLabel,
} from '../../../../core/api/menu/menu.types';

type UseAllergens = {
  allergens: NutritionMenuItemLabel[];
};

export const useAllergens = (
  menuItemNutritionInfo: NutritionMenuItem,
  menuItemOptionSetItemNutritionInfos: NutritionMenuItem[],
): UseAllergens => {
  const getAllAllergensFromMenuItemAndOptions =
    (): NutritionMenuItemLabel[] => {
      const allergensArray: NutritionMenuItemLabel[] = [];

      const checkIfExistsAndPush = (
        nutritionInfoLabel: NutritionMenuItemLabel,
      ): void => {
        if (!allergensArray.some((x) => x.Name === nutritionInfoLabel.Name)) {
          allergensArray.push(nutritionInfoLabel);
        }
      };

      const addAllergenValuesToArray = (
        nutritionInfoLabel: NutritionMenuItemLabel,
      ): void => {
        nutritionInfoLabel.Values.forEach((value) => {
          const newLabel = {
            ...nutritionInfoLabel,
            Name: value,
          };
          delete newLabel.Values;
          checkIfExistsAndPush(newLabel);
        });
      };

      menuItemNutritionInfo?.Labels.forEach((label) => {
        if (label.Values?.length > 0) {
          addAllergenValuesToArray(label);
        } else {
          label.Name && checkIfExistsAndPush(label);
        }
      });

      menuItemOptionSetItemNutritionInfos?.forEach(
        (menuItemOptionSetItemNutritionInfo) => {
          menuItemOptionSetItemNutritionInfo.Labels.forEach((label) => {
            if (label.Values?.length > 0) {
              addAllergenValuesToArray(label);
            } else {
              checkIfExistsAndPush(label);
            }
          });
        },
      );

      return allergensArray;
    };

  const allergens = useMemo(
    (): NutritionMenuItemLabel[] => getAllAllergensFromMenuItemAndOptions(),
    [menuItemNutritionInfo, menuItemOptionSetItemNutritionInfos],
  );

  return { allergens };
};
